import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import 'normalize.css'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
import Mock from './mock'
Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import './assets/scss/main.scss';
import httpService from '../src/api/http'
import echarts from 'echarts';
import pdfSignature from 'vue-pdf-signature'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.component('pdfSignature', pdfSignature);

NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  mode: 'history',
  routes
})
Vue.prototype.$api = httpService;
// Vue.prototype.fileUrl = "http://127.0.0.1:8001/pubFile/"
// Vue.prototype.mainUrl = "http://127.0.0.1:8001/"
Vue.prototype.fileUrl = "https://emc.b-tronsemi.com/emc-api/pubFile/"
Vue.prototype.domain = "https://emc.b-tronsemi.com/"
Vue.prototype.mainUrl = "https://emc.b-tronsemi.com/emc-api/"
Vue.prototype.$echarts = echarts;
Vue.prototype.casBaseUrl = "https://emc-console.b-tronsemi.com/";
Vue.prototype.icoUrl = "https://emc-console.b-tronsemi.com/favicon.ico"
Vue.prototype.$pdfSignature = pdfSignature;

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  // if (!user && to.path != '/login') {
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
  next()
})

router.afterEach(transition => {
  NProgress.done();
});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')

window.onload = function() {
  // document.body.style.zoom="80%";
}



// WEBPACK FOOTER //
// ./src/main.js